import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import api from '../../common/services/api';
import { marcarMensagemLida } from '../../store/user/slice';
import DetailPanel from './components/DetailPanel';
import NotificationList from './components/NotificationList';
import './styles.css';

const TABS = ['Todas'];

export const MensageriaPage = () => {
  const [isLoadingMsg, setIsLoadingMsg] = useState(false);
  const { matricula, token } = useSelector((state) => state.user.data);
  const mensageria = useSelector((state) => state.user.mensageria);
  const dispatch = useDispatch();
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [activeTab, setActiveTab] = useState('Todas');

  const location = useLocation();
  const idMsgParams = location.state?.params?.id;

  const handleOpenMensageria = useCallback(
    (idMensageria) => {
      setIsLoadingMsg(true);

      api
        .get('ObterMensageriaParticipanteId', {
          params: {
            matricula,
            token,
            idMsg: idMensageria,
          },
        })
        .then((response) => {
          setSelectedNotification(response.data[0]);
          dispatch(marcarMensagemLida(idMensageria));
          setIsLoadingMsg(false);
        });
    },
    [matricula, token, dispatch]
  );

  useEffect(() => {
    if (idMsgParams) {
      handleOpenMensageria(idMsgParams);
    }
  }, [idMsgParams, handleOpenMensageria]);

  return (
    <>
      <Helmet>
        <title>Forluz - Notificações</title>
      </Helmet>

      <div className="mensageria-page">
        <h1 className="mensageria-page-title">Notificações</h1>

        <div className="mensageria-tabs">
          {TABS.map((tab) => (
            <button
              key={tab}
              type="button"
              className={`mensageria-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="mensageria-content">
          <NotificationList
            mensageria={mensageria}
            selectedNotification={selectedNotification}
            handleOpenMensageria={handleOpenMensageria}
          />
          <div className="mensageria-detail">
            <DetailPanel
              isLoadingMsg={isLoadingMsg}
              selectedNotification={selectedNotification}
            />
          </div>
        </div>
      </div>
    </>
  );
};
